import styled from 'styled-components';

export const NotAvailableWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 5px;
`;
